
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesWithoutTaxGrid extends Serenity.EntityGrid<POSSalesWithoutTaxRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesWithoutTax'; }
        protected getDialogType() { return POSSalesWithoutTaxDialog; }
        protected getIdProperty() { return POSSalesWithoutTaxRow.idProperty; }
        protected getInsertPermission() { return POSSalesWithoutTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesWithoutTaxRow.localTextPrefix; }
        protected getService() { return POSSalesWithoutTaxService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
            this.toolbar.findButton('add-button').find('.button-inner').text('New Invoice');
            this.slickGrid.setOptions({ rowHeight: 30 });

            //this.addButtonClick();
        }

        protected addButtonClick() {
            
            let now = new Date();
            var voucher = FormatHelper.GetVoucherNo(91);
            var userDefinition = Q.Authorization.userDefinition;

            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[91].AutoPosting;
            this.editItem(<POSSalesWithoutTaxRow>{
                VoucherNo: voucher,
                Line_No: 0,
                VoucherTypeId: 91,
                CompanyId:  userDefinition.CompanyId,
                FinancialYearId:  userDefinition.FinancialYearId,
                UserId:  userDefinition.UserId,
                CurrencyId:  userDefinition.CurrencyId,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}